import React from 'react';

function EventLocation(props) {
    if (typeof props.location === 'string') {
        return <span>{props.location}</span>;
    }

    if (props.location[0] === 'Other') {
        return <span>{props.location[1]}</span>;
    }

    return <span>{props.location[0]}</span>;
}

EventLocation.propTypes = {
    location: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array]).isRequired,
};

export default EventLocation;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/eventLocation.jsx